interface TelegramLocationData {
  latitude: number
  longitude: number
  altitude: number | null
  course: number | null
  speed: number | null
  horizontal_accuracy: number | null
}

interface TelegramLocationManager {
  isInited: boolean
  isLocationAvailable: boolean
  isAccessGranted: boolean
  init(callback?: () => void): void
  getLocation(callback: (data: TelegramLocationData | null) => void): void
  openSettings(): void
}

declare global {
  interface Window {
    Telegram?: {
      WebApp?: {
        LocationManager?: TelegramLocationManager
      }
    }
  }
}

export function getLocation(): Promise<{ latitude: number; longitude: number }> {
  return new Promise((resolve, reject) => {
    const lm = window.Telegram?.WebApp?.LocationManager

    if (lm) {
      const doGet = () => {
        lm.getLocation((data) => {
          if (data) {
            resolve({ latitude: data.latitude, longitude: data.longitude })
          } else {
            reject(new Error('Location access denied. Please enable location in settings.'))
          }
        })
      }

      if (!lm.isInited) {
        lm.init(doGet)
      } else {
        doGet()
      }
      return
    }

    // Browser fallback
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by your browser.'))
      return
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
      (err) => {
        if (err.code === err.PERMISSION_DENIED) {
          reject(new Error('Location access denied.'))
        } else {
          reject(new Error('Failed to get location. Please try again.'))
        }
      },
      { enableHighAccuracy: true, timeout: 10000 }
    )
  })
}
